module.exports = __webpack_public_path__ + "img/php.48c15f67.png";